const reducer = async (action, data, state, prevState) => {

  switch (action) {
    case "GET": {
      const detailData = state[state.primaryField]?.detailData;
      const ExtSysFilled = detailData.ExtSys ? true : false;
      const AplFilled = detailData.Apl ? true : false;
      let newSchema = prevState.detailSchema.map(x => {
        switch (x.field) {
          case "Apl": {
            x.required = detailData.IApiKey > 0 ? AplFilled : true;
            x.disabled = ExtSysFilled;
            break;
          }
          case "ExtSys": {
            x.required = detailData.IApiKey > 0 ? ExtSysFilled : true;
            x.disabled = AplFilled;
            break;
          }
          default:
            break;
        }
        return x;
      });
      return { ...state, detailSchema: newSchema };
    }
    case "CHANGE": {
      let newSchema;
      switch (data.field) {
        case "Apl": {
          if (!data.value) {
            newSchema = prevState.detailSchema.map(x => x.field === "ExtSys" ? { ...x, disabled: false, required: true } : x.field === "Apl" ? { ...x, required: true } : x)
          }
          else {
            newSchema = prevState.detailSchema.map(x => x.field === "ExtSys" ? { ...x, disabled: true, required: false } : x.field === "Apl" ? { ...x, required: true } : x)
          }
          return { ...state, detailSchema: newSchema };
        }
        case "ExtSys": {
          if (!data.value) {
            newSchema = prevState.detailSchema.map(x => x.field === "Apl" ? { ...x, disabled: false, required: true } : x.field === "ExtSys" ? { ...x, required: true } : x)
          }
          else {
            newSchema = prevState.detailSchema.map(x => x.field === "Apl" ? { ...x, disabled: true, required: false } : x.field === "ExtSys" ? { ...x, required: true } : x)
          }
          return { ...state, detailSchema: newSchema };
        }
        default:
          break;
      }
    }
    default:
      return state;
  }
}

export default reducer;